import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, Divider } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import React from 'react';

interface PreviewProps {
  toggleModal: boolean,
  data: string,
  loading: boolean,
  onQuitModal: () => void
}

const useStyles = makeStyles((theme) => ({
  dialogContent: {
    display: 'flex',
    flexDirection: 'row'
  }
}));

const Preview = (props: PreviewProps) => {
  const classes = useStyles();

  return (
    <Dialog open={props.toggleModal} onClose={props.onQuitModal} maxWidth="md">
      <DialogTitle>
        Pré-visualisation
      </DialogTitle>
      <Divider />
      <DialogContent className={classes.dialogContent}>
        {props.loading && <CircularProgress />}
        <div dangerouslySetInnerHTML={{__html: props.data}} />
      </DialogContent>
      <DialogActions>
        <Button onClick={props.onQuitModal}>Quitter</Button>
      </DialogActions>
    </Dialog>
  );
}

export default Preview;